import { create } from 'zustand';
import useNodesProjectStore from './useNodesProjectStore';
import useNodesFeedStore from './useNodesFeedStore';

const initialNodesUiState = {
  isTemplatesSideBarOpen: false,
  isDataPreviewSideBarOpen: false,
  isAsideItemLoading: false,
};

const useNodesUiStore = create((set, get) => ({
  ...initialNodesUiState,

  reset: () => set({ ...initialNodesUiState }),

  setTemplatesSideBarOpen: (value) => set({ isTemplatesSideBarOpen: value }),
  setDataPreviewSideBarOpen: (value) => set({ isDataPreviewSideBarOpen: value }),
  setIsAsideItemLoading: (value) => set({ isAsideItemLoading: value }),

  showTemplatesSideBar: async () => {
    const { isTemplatesSideBarOpen } = get();
    set({ isDataPreviewSideBarOpen: false });
    if (!isTemplatesSideBarOpen) {
      set({ isAsideItemLoading: true });
      try {
        await useNodesProjectStore.getState().loadTemplates();
      } finally {
        set({ isAsideItemLoading: false });
      }
    }
    set({ isTemplatesSideBarOpen: !isTemplatesSideBarOpen });
  },

  showDataPreviewSideBar: () => {
    const { isDataPreviewSideBarOpen } = get();
    if (!isDataPreviewSideBarOpen) {
      void useNodesFeedStore.getState().resetFeedSearch();
    }
    set({
      isDataPreviewSideBarOpen: !isDataPreviewSideBarOpen,
      isTemplatesSideBarOpen: false,
    });
  },
}));

export default useNodesUiStore;
